module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-query"
  }, [_c('div', {
    staticClass: "field-query-block",
    attrs: {
      "layout": "row",
      "layout-align": "space-between stretch"
    }
  }, [_c('input', {
    ref: "contentInput",
    attrs: {
      "type": "text",
      "flex": "",
      "placeholder": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.openPanel($event.target.value)
      },
      "input": function($event) {
        _vm.search($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-icon",
    attrs: {
      "layout": "row",
      "layout-align": "center center"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.show = true
      }
    }
  }, [_c('k-icon', {
    attrs: {
      "xlink": "#icon-search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "sl-bx",
    style: ({
      zIndex: _vm.$knife.getZIndex()
    }),
    on: {
      "mouseenter": function($event) {
        _vm.$refs.contentInput.onblur = null
      },
      "mouseleave": function($event) {
        _vm.$refs.contentInput.onblur = _vm.hidePanel
      }
    }
  }, [_c('table', {
    staticClass: "sl-bx-table k_e_t"
  }, [_c('thead', [_c('tr', _vm._l((_vm.fields), function(cell, i) {
    return _c('td', {
      key: i
    }, [_vm._v(_vm._s(cell.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          _vm.choose(item)
        }
      }
    }, _vm._l((_vm.fields), function(cell, i) {
      return _c('td', {
        key: i
      }, [_vm._v(_vm._s(item[cell.name]))])
    }))
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eabbb35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KQuery.vue
// module id = 117
// module chunks = 1